import findInObject from '../findInObject'
import { formatPhoneNumber } from '../phoneNumberFormatter'
import { phoneNumbers } from '../static-data/phoneNumbers'

/**
 * phoneFilter
 *
 * This is a content filter function. It receives content,
 * obj, and originalMatch from the shortcodeParser.
 *
 * The purpose of this function is to replace "phone" shortcodes with a
 * phone number.
 *
 * phoneFilter requires two properties, shortcode and phone.
 *
 * {{ shortcode: "phone", "content": "umaAdmissions.number" }}
 *
 * @param {string} content - The full chunk of content
 * @param {object} obj - The shortcode as a JS object
 * @param {string} originalMatch - The original match, useful for replacing the shortcode
 *
 * @returns {string} content
 */
const phoneFilter = (content, obj, originalMatch) => {
  const objType = findInObject('shortcode', obj)

  if (objType === 'phone') {
    const number = `${findInObject(findInObject('numberKey', obj), phoneNumbers)}`
    const updatedContent = `<a href="tel:${number}">${formatPhoneNumber(number)}</a>`
    content = content.replace(originalMatch, updatedContent)
  }

  return content
}

export default phoneFilter
